import Enum from '@/modules/core/app/helpers/Enum';
import { EstateDetailsMainTabValue } from '@/modules/ops/constants/EstateDetailsMainTabValue';
import { EstateDetailsCollapsesTabValue } from '@/modules/ops/constants/EstateDetailsCollapsesTabValue';

// Snapshot is left out: EPs without canGenerateEstateSnapshot land on Summary instead.
export class MessageClaraDraftSourceTab extends Enum {
  key!: string;

  static NOTES: MessageClaraDraftSourceTab = { key: EstateDetailsMainTabValue.NOTES };
  static DOCUMENTS: MessageClaraDraftSourceTab = { key: EstateDetailsMainTabValue.DOCUMENTS };
  static INBOX: MessageClaraDraftSourceTab = { key: EstateDetailsMainTabValue.INBOX };
  static STEPS: MessageClaraDraftSourceTab = { key: EstateDetailsMainTabValue.STEPS };
  static DETAILS: MessageClaraDraftSourceTab = { key: EstateDetailsCollapsesTabValue.DETAILS };
  static RELATED: MessageClaraDraftSourceTab = { key: EstateDetailsCollapsesTabValue.RELATED };
  static COMMENTS: MessageClaraDraftSourceTab = { key: EstateDetailsCollapsesTabValue.COMMENTS };
}
